import { useHttp } from '../http'

export const useClubAthleteHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`club-athletes/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`club-athletes`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`club-athletes/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`club-athletes`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`club-athletes/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`club-athletes/${id}/photo`, payload)
    }

    return {
        find,
        create,
        update,
        get,
        del,
        photo
    }
}
